import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useScreenSize } from "../../_context/ScreenSizeProvider";
import IconBreadcrumbs from "./IconBreadcrumbs";
const MainSection = ({ childrenWithProps }) => {
  return (
    <Box
      style={{
        position: "relative",
        padding: "0px 1rem",
        margin: "0px",
        boxSizing: "border-box",
        width: "calc(100%)",
        overflow: "hidden",

      }}
    >
      <IconBreadcrumbs />
      <Box
        style={{
          position: "relative",
          padding: "0px",
          margin: "0px",
   width:"100%"
        }}
      >
        {childrenWithProps }
      </Box>
    </Box>
  );
};

MainSection.propTypes = {
  childrenWithProps: PropTypes.node.isRequired,
};

export default MainSection;
